import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBitcoinComponent } from './simple-icons-bitcoin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBitcoinComponent ],
    exports:      [ SimpleIconsBitcoinComponent ],
    bootstrap:    []
})
export class SimpleIconsBitcoinModule {}
